import React from "react";
import styled from "styled-components";
import { RightOutlined } from "@ant-design/icons";
import { StageDefinition } from "../../utils/campaignStatusTrackingUtils";

const CardButton = styled.button<{ $active?: boolean; $stageColor: string }>`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	min-height: 57px;
	padding: 10px 12px;
	border-radius: 12px;
	border: 1px solid ${(p) => (p.$active ? p.$stageColor : "#dde2fa")};
	background: #fafbff;
	cursor: pointer;
	text-align: left;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;

	&:hover {
		border-color: ${(p) => (p.$active ? p.$stageColor : "#bdc6f2")};
		box-shadow: ${(p) => (p.$active ? "none" : "0 2px 8px rgba(21, 89, 165, 0.08)")};
	}
`;

const DotWrap = styled.span`
	display: flex;
	align-items: flex-start;
	padding-top: 6px;
	height: 23px;
	flex-shrink: 0;
`;

const Dot = styled.span<{ $color: string }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: ${(p) => p.$color};
	flex-shrink: 0;
`;

const TextBlock = styled.div`
	display: flex;
	flex: 1 1 auto;
	flex-direction: column;
	align-items: flex-start;
	min-width: 0;
	overflow: hidden;
`;

const StageLabel = styled.span`
	font-family: "Poppins", sans-serif;
	font-size: 13px;
	font-weight: 400;
	color: #303030;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
`;

const SubLabel = styled.span`
	font-family: "Poppins", sans-serif;
	font-size: 11px;
	font-weight: 600;
	line-height: 1.35;
	color: #9e9e9e;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
`;

const Count = styled.span`
	font-family: "Poppins", sans-serif;
	font-size: 18px;
	font-weight: 600;
	line-height: 1.2;
	color: #303030;
	flex-shrink: 0;
`;

const Chevron = styled(RightOutlined)`
	font-size: 10px;
	color: #9e9e9e;
	flex-shrink: 0;
`;

interface StatusStageCardProps {
	stage: StageDefinition;
	count: number;
	active?: boolean;
}

export const StatusStageCard: React.FC<StatusStageCardProps> = ({ stage, count, active }) => {
	return (
		<CardButton
			type="button"
			$active={active}
			$stageColor={stage.color}
			aria-pressed={!!active}
			aria-label={`${stage.label}, ${count} creators`}
		>
			<DotWrap>
				<Dot $color={stage.color} />
			</DotWrap>
			<TextBlock>
				<StageLabel>{stage.label}</StageLabel>
				<SubLabel title={stage.subLabel}>{stage.subLabel}</SubLabel>
			</TextBlock>
			<Count>{count}</Count>
			<Chevron />
		</CardButton>
	);
};
